import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import i18n from '../../../Shared/Translation/i18n';
import { ApiUrl} from '../../../project/Defines.js';
import { EVENT_NAME, dispatchCustomEvent } from '../../../project/utilities';
import DetailView from '../../../Shared/DetailView';
import useDetail from '../../../Shared/useDetail';
import InputCont from '../../../Shared/Form/InputCont';
import { Ajax } from '../../../components/Ajax';
import { hideLoader, showLoader } from '../../../Shared/Loader';

import { message } from 'antd';
import { useDispatch } from 'react-redux';

const listUpdateEvent = EVENT_NAME.FAQ_THERCODIM_LIST_UPDATE;
const loaderName = 'UPDATE_LOADER';
/**
 * ...
 * @exports ThercodimFaqDetails
 */

export default function ThercodimFaqDetails(props) {
    const { windowKey, data } = props;
    const [salesNetworkLanguage, setSalesNetworkLanguage] = useState([]);
    const [isDisabled, setIsDisabled] = useState(false);
    const [thercodimFaq, setThercodimFaq] = useState([]);
    const [hasChanges, setHasChanges] = useState(false);
    const { id } = useParams();
    const dispatch = useDispatch();

    const { isNew, dataItem, updateData, closePopup, /*hasChanges, setDataItem, onChangeData, detailRef,*/ onDetailDelete, validation } = useDetail({
        data: data || { ID: id !== "create" ? id : 0 },
        windowKey,
        updateUrl: ApiUrl.ThercodimFaqUpdate,
        dataLoadUrl: ApiUrl.ThercodimFaqLoad,
        deleteUrl: ApiUrl.ThercodimFaqDelete,
        nameField: 'order',
        //backPage: AppPages.Faq,
        listUpdateEvent,
        //detailUrl: Project.getPageUrl(AppPages.FaqThercodimDetails),
        changingValidation: true,
        onRecordDeleted: () => {
            setHasChanges(false);
        }
    });

    useEffect(() => {
        if (dataItem) {
            Ajax.get({
                url: ApiUrl.SalesNetworkLanguagesLoad,
                data: { networkID: dataItem.salesnetworkId },
                success: function (response) {
                    if (response && !response.HasError) {
                        setSalesNetworkLanguage(response.data);
                    } else {
                        message.error();
                    }
                },
            })
        }
    }, [dataItem && dataItem.salesnetworkId]);// eslint-disable-line react-hooks/exhaustive-deps

    const loadData = useCallback((dataItem_ID) => {// NOSONAR
        Ajax.post({
            url: ApiUrl.LoadThercodimFaq,
            data: { id: dataItem_ID },
            success: function (response) {
                hideLoader(loaderName);

                if (response) {
                    const _response = [...response];

                    if (salesNetworkLanguage) {
                        for (const element of salesNetworkLanguage) {
                            if (element.isSelected && !response.some(t => t.language.trim() === element.Code.trim())) {
                                _response.push({
                                    HasError: false,
                                    ID: dataItem.ID ? dataItem.ID : -1,
                                    Message: null,
                                    answer: "",
                                    language: element.Code.trim(),
                                    languageId: element.ID,
                                    order: dataItem.order,
                                    question: "",
                                    salesnetworkId: dataItem.salesnetworkId,
                                    salesNetwork: ""
                                });
                            }
                        }
                    }
                    setThercodimFaq(_response);
                    setHasChanges(false);
                } else {
                    message.error();
                }
            },
        });
    }, [setThercodimFaq, setHasChanges, salesNetworkLanguage, dataItem]);

    useEffect(() => {
        if (dataItem && !isDisabled && salesNetworkLanguage) {
            loadData(dataItem.ID);
        }
    }, [salesNetworkLanguage]);// eslint-disable-line react-hooks/exhaustive-deps

    const onChangeThercodimFaq = useCallback((e, language) => {
        const newThercodimFaq = [...thercodimFaq];
        const index = newThercodimFaq.findIndex(f => f.language.trim() === language.trim());

        if (index >= 0) {
            setHasChanges(hasChanges || newThercodimFaq[index][e.target.name] !== e.target.value);
            newThercodimFaq[index][e.target.name] = e.target.value;
        }

        setThercodimFaq(newThercodimFaq);
    }, [thercodimFaq, hasChanges]);

    const updateThercodimFaqItems = useCallback((_response) => {
        showLoader(loaderName);

        for (const element of thercodimFaq) {
            element.ID = _response.ID;
            element.salesnetworkId = _response.salesnetworkId;
        }

        Ajax.post({
            url: ApiUrl.UpdateThercodimFaqItem,
            data: { data: thercodimFaq },
            success: function (response) {

                setIsDisabled(false);
                loadData(_response.ID);

                dispatchCustomEvent(listUpdateEvent, { action: 'update' });
                closePopup();
            },
            error: function () {
                hideLoader(loaderName);
                setIsDisabled(false);
            }
        })
    }, [loadData, thercodimFaq, closePopup]);

    const isEmptyItems = useCallback(() => {
        let hasQuestion = false;
        let hasAnswer = false;

        for (const element of thercodimFaq) {
            if (element.question !== "") {
                hasQuestion = true;
            } else if (element.answer !== "") {
                hasAnswer = true;
            }
        }

        return !hasQuestion && !hasAnswer;
    }, [thercodimFaq]);

    const validate = useCallback(() => {
        let questionEmpty = false;
        let answerEmpty = false;

        for (const element of thercodimFaq) {
            if (element.question !== "" && element.answer === "") {
                answerEmpty = true;
            } else if (element.question === "" && element.answer !== "") {
                questionEmpty = true;
            }
        }

        if (answerEmpty && questionEmpty) {
            message.error("Please check answer and question.");
        } else if (answerEmpty) {
            message.error("Please check answer.");
        } else if (questionEmpty) {
            message.error("Please check question.");
        } else if (isNew && isEmptyItems()) {
            message.error("Please check answer and question.");
            return false;
        }

        return !answerEmpty && !questionEmpty;
    }, [thercodimFaq, isNew, isEmptyItems]);

    const update = useCallback(() => {
        if (validate()) {
            setIsDisabled(true);
            setHasChanges(false);

            let canDelete = isEmptyItems();

            if (canDelete) {
                //deletefaq()
                onDetailDelete(dataItem);
                dispatch(closePopup(windowKey));
                //dispatchCustomEvent(listUpdateEvent, { action: 'update' });
            } else {
                updateData(updateThercodimFaqItems);
            }
        }
    }, [updateData, closePopup, updateThercodimFaqItems, onDetailDelete, dataItem, isEmptyItems, validate, windowKey, dispatch]);

    return (<>
        {dataItem && <DetailView
            hasChanges={hasChanges}
            //backUrl={Project.getPageUrl(AppPages.Faq)}
            //title={isNew ? i18n('text.faq') : dataItem.order}
            showPopup
            
        >
            <view >
                {/* <form> */}
                <div className="form_container">
                    <div className="section_group">
                        <div className="sections">
                            <div className="form_fields">
                                <div className="section_title"><text>question</text></div>
                                <div className="form_separator"></div>
                            </div>
                            {thercodimFaq && thercodimFaq.map((f, i) => {
                                return <InputCont label={f.language} key={i} // NOSONAR
                                    inputProps={{ validation, name: "question", value: f.question, onChange: e => onChangeThercodimFaq(e, f.language) }} />
                            })}
                        </div>

                        <div className="sections">
                            <div className="form_fields">
                                <div className="section_title"><text>answer</text></div>
                                <div className="form_separator"></div>
                            </div>
                            {thercodimFaq && thercodimFaq.map((f, i) => {
                                return <InputCont label={f.language} key={i} // NOSONAR
                                    inputProps={{ validation, name: "answer", value: f.answer, onChange: e => onChangeThercodimFaq(e, f.language) }} />
                            })}
                        </div>
                    </div>
                </div>
                <toolbar>
                    <wrap>
                        <action right=''>
                            <div
                                onClick={update}
                                //onClick={(e) => updateData(updateSuccessCallback)}
                                disabled={isDisabled}
                                className={hasChanges ? ' button primary' : 'button'}><icon>save</icon>{i18n('text.save')}
                            </div>
                            {/* {dataItem.ID > 0 &&
                                <div className='button' onClick={(e) => {
                                    onDetailDelete(dataItem);
                                    //onClose();
                                }}>
                                    <icon>delete</icon>{i18n('text.delete')}
                                </div>} */}
                        </action>
                    </wrap>
                </toolbar>
                {/* </form> */}
            </view>
        </DetailView>}
    </>);
}

